// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/delivery/v1/resources.proto (package annealing.delivery.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AssetEventType, AssetPinReason, ChartRepositoryState, ChartState, ClusterState, GitRepositoryState, HealthState, IgnoreDifferenceState, IgnoreDifferenceType, IncarnationState, RolloutState, RolloutStepKind, RolloutStepState, SshKeyState, SshKnownHostState, SyncState } from "./enums_pb";
import { file_annealing_delivery_v1_enums } from "./enums_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file annealing/delivery/v1/resources.proto.
 */
export const file_annealing_delivery_v1_resources: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_timestamp, file_annealing_delivery_v1_enums]);

/**
 * User represents a person who can perform actions.
 *
 * @generated from message annealing.delivery.v1.User
 */
export type User = Message<"annealing.delivery.v1.User"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;

  /**
   * @generated from field: annealing.delivery.v1.GoogleUser google_user = 3;
   */
  googleUser?: GoogleUser;
};

/**
 * Describes the message annealing.delivery.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 0);

/**
 * @generated from message annealing.delivery.v1.SshKey
 */
export type SshKey = Message<"annealing.delivery.v1.SshKey"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: annealing.delivery.v1.SshKeyState state = 2;
   */
  state: SshKeyState;

  /**
   * @generated from field: string algorithm = 3;
   */
  algorithm: string;

  /**
   * @generated from field: string fingerprint_sha256 = 4;
   */
  fingerprintSha256: string;

  /**
   * @generated from field: string public_key = 5;
   */
  publicKey: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 6;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 7;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.SshKey.
 * Use `create(SshKeySchema)` to create a new message.
 */
export const SshKeySchema: GenMessage<SshKey> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 1);

/**
 * @generated from message annealing.delivery.v1.SshKnownHost
 */
export type SshKnownHost = Message<"annealing.delivery.v1.SshKnownHost"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: annealing.delivery.v1.SshKnownHostState state = 2;
   */
  state: SshKnownHostState;

  /**
   * @generated from field: string hostname = 3;
   */
  hostname: string;

  /**
   * @generated from field: string algorithm = 4;
   */
  algorithm: string;

  /**
   * @generated from field: string fingerprint_sha256 = 5;
   */
  fingerprintSha256: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 6;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 7;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.SshKnownHost.
 * Use `create(SshKnownHostSchema)` to create a new message.
 */
export const SshKnownHostSchema: GenMessage<SshKnownHost> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 2);

/**
 * @generated from message annealing.delivery.v1.IgnoreDifference
 */
export type IgnoreDifference = Message<"annealing.delivery.v1.IgnoreDifference"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: annealing.delivery.v1.IgnoreDifferenceState state = 2;
   */
  state: IgnoreDifferenceState;

  /**
   * @generated from field: annealing.delivery.v1.IgnoreDifferenceType type = 3;
   */
  type: IgnoreDifferenceType;

  /**
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: string object_group = 5;
   */
  objectGroup: string;

  /**
   * @generated from field: string object_kind = 6;
   */
  objectKind: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 7;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 8;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.IgnoreDifference.
 * Use `create(IgnoreDifferenceSchema)` to create a new message.
 */
export const IgnoreDifferenceSchema: GenMessage<IgnoreDifference> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 3);

/**
 * Cluster represents a Kubernetes cluster.
 *
 * @generated from message annealing.delivery.v1.Cluster
 */
export type Cluster = Message<"annealing.delivery.v1.Cluster"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: string kube_system_uid = 3;
   */
  kubeSystemUid: string;

  /**
   * @generated from field: int32 asset_count = 4;
   */
  assetCount: number;

  /**
   * @generated from field: annealing.delivery.v1.ClusterState state = 5;
   */
  state: ClusterState;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 6;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 7;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refresh_time = 8;
   */
  refreshTime?: Timestamp;

  /**
   * @generated from field: string distribution = 9;
   */
  distribution: string;
};

/**
 * Describes the message annealing.delivery.v1.Cluster.
 * Use `create(ClusterSchema)` to create a new message.
 */
export const ClusterSchema: GenMessage<Cluster> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 4);

/**
 * Asset represents an object in a cluster.
 *
 * @generated from message annealing.delivery.v1.Asset
 */
export type Asset = Message<"annealing.delivery.v1.Asset"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string revision = 2;
   */
  revision: string;

  /**
   * @generated from field: annealing.delivery.v1.AssetPinReason pin_reason = 3;
   */
  pinReason: AssetPinReason;

  /**
   * @generated from field: string api_version = 4;
   */
  apiVersion: string;

  /**
   * @generated from field: annealing.delivery.v1.SyncState sync_state = 5;
   */
  syncState: SyncState;

  /**
   * @generated from field: annealing.delivery.v1.HealthState health_state = 6;
   */
  healthState: HealthState;

  /**
   * @generated from field: string payload = 7;
   */
  payload: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 8;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 9;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refresh_time = 10;
   */
  refreshTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 5);

/**
 * Application represents a collection of objects that are versioned
 * and deployed together.
 *
 * @generated from message annealing.delivery.v1.Application
 */
export type Application = Message<"annealing.delivery.v1.Application"> & {
  /**
   * The name of the application.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The sync state of the application.
   *
   * @generated from field: annealing.delivery.v1.SyncState sync_state = 2;
   */
  syncState: SyncState;

  /**
   * The health state of the application.
   *
   * @generated from field: annealing.delivery.v1.HealthState health_state = 3;
   */
  healthState: HealthState;

  /**
   * The source configuration of the application.
   *
   * @generated from field: annealing.delivery.v1.ApplicationSource source = 4;
   */
  source?: ApplicationSource;

  /**
   * The target configuration of the application.
   *
   * @generated from field: annealing.delivery.v1.ApplicationTarget target = 5;
   */
  target?: ApplicationTarget;

  /**
   * Output only. The number of objects associated with the application.
   *
   * @generated from field: int32 asset_count = 6;
   */
  assetCount: number;

  /**
   * @generated from field: string desired_incarnation = 7;
   */
  desiredIncarnation: string;

  /**
   * @generated from field: string target_incarnation = 8;
   */
  targetIncarnation: string;

  /**
   * Output only. The time when the application was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 9;
   */
  createTime?: Timestamp;

  /**
   * Output only. The time when the application was updated.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 10;
   */
  updateTime?: Timestamp;

  /**
   * Output only. The time when the application was refreshed.
   *
   * @generated from field: google.protobuf.Timestamp refresh_time = 11;
   */
  refreshTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.Application.
 * Use `create(ApplicationSchema)` to create a new message.
 */
export const ApplicationSchema: GenMessage<Application> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 6);

/**
 * @generated from message annealing.delivery.v1.ApplicationSource
 */
export type ApplicationSource = Message<"annealing.delivery.v1.ApplicationSource"> & {
  /**
   * @generated from field: annealing.delivery.v1.GitSource git = 1;
   */
  git?: GitSource;

  /**
   * @generated from field: annealing.delivery.v1.ChartSource chart = 2;
   */
  chart?: ChartSource;
};

/**
 * Describes the message annealing.delivery.v1.ApplicationSource.
 * Use `create(ApplicationSourceSchema)` to create a new message.
 */
export const ApplicationSourceSchema: GenMessage<ApplicationSource> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 7);

/**
 * @generated from message annealing.delivery.v1.ApplicationTarget
 */
export type ApplicationTarget = Message<"annealing.delivery.v1.ApplicationTarget"> & {
  /**
   * The cluster to deploy to.
   *
   * @generated from field: string cluster = 1;
   */
  cluster: string;

  /**
   * The namespace to use by default.
   *
   * @generated from field: string namespace = 2;
   */
  namespace: string;
};

/**
 * Describes the message annealing.delivery.v1.ApplicationTarget.
 * Use `create(ApplicationTargetSchema)` to create a new message.
 */
export const ApplicationTargetSchema: GenMessage<ApplicationTarget> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 8);

/**
 * Incarnation represents a configuration snapshot for a application.
 * Incarnations are immutable.
 *
 * @generated from message annealing.delivery.v1.Incarnation
 */
export type Incarnation = Message<"annealing.delivery.v1.Incarnation"> & {
  /**
   * The name of the incarnation.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Output only. The state of the incarnation.
   *
   * @generated from field: annealing.delivery.v1.IncarnationState state = 2;
   */
  state: IncarnationState;

  /**
   * Output only. The number of files.
   *
   * @generated from field: int32 file_count = 3;
   */
  fileCount: number;

  /**
   * Output only. The number of objects.
   *
   * @generated from field: int32 asset_count = 4;
   */
  assetCount: number;

  /**
   * Output only. The tool used to render the incarnation.
   *
   * @generated from field: string tool = 5;
   */
  tool: string;

  /**
   * Output only. The fingerprint of all objects.
   *
   * @generated from field: string fingerprint = 6;
   */
  fingerprint: string;

  /**
   * The source of the incarnation.
   *
   * @generated from field: annealing.delivery.v1.IncarnationSource source = 7;
   */
  source?: IncarnationSource;

  /**
   * The target of the incarnation.
   *
   * @generated from field: annealing.delivery.v1.IncarnationTarget target = 8;
   */
  target?: IncarnationTarget;

  /**
   * Output only. The time the incarnation was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 9;
   */
  createTime?: Timestamp;

  /**
   * Output only. The time the incarnation was updated.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 10;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.Incarnation.
 * Use `create(IncarnationSchema)` to create a new message.
 */
export const IncarnationSchema: GenMessage<Incarnation> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 9);

/**
 * @generated from message annealing.delivery.v1.IncarnationSource
 */
export type IncarnationSource = Message<"annealing.delivery.v1.IncarnationSource"> & {
  /**
   * @generated from field: annealing.delivery.v1.GitSource git = 1;
   */
  git?: GitSource;

  /**
   * @generated from field: annealing.delivery.v1.ChartSource chart = 2;
   */
  chart?: ChartSource;
};

/**
 * Describes the message annealing.delivery.v1.IncarnationSource.
 * Use `create(IncarnationSourceSchema)` to create a new message.
 */
export const IncarnationSourceSchema: GenMessage<IncarnationSource> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 10);

/**
 * @generated from message annealing.delivery.v1.IncarnationTarget
 */
export type IncarnationTarget = Message<"annealing.delivery.v1.IncarnationTarget"> & {
  /**
   * The cluster group to deploy to.
   *
   * @generated from field: string cluster_group = 1;
   */
  clusterGroup: string;

  /**
   * The namespace to use by default.
   *
   * @generated from field: string namespace = 2;
   */
  namespace: string;
};

/**
 * Describes the message annealing.delivery.v1.IncarnationTarget.
 * Use `create(IncarnationTargetSchema)` to create a new message.
 */
export const IncarnationTargetSchema: GenMessage<IncarnationTarget> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 11);

/**
 * @generated from message annealing.delivery.v1.GitSource
 */
export type GitSource = Message<"annealing.delivery.v1.GitSource"> & {
  /**
   * The repository containing application configuration.
   *
   * @generated from field: string repository = 1;
   */
  repository: string;

  /**
   * The ref of the repository. Can be either a branch or tag.
   *
   * @generated from field: string revision = 2;
   */
  revision: string;

  /**
   * The path within the repository.
   *
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * Output only. The latest commit in the branch.
   *
   * @generated from field: string revision_commit = 4;
   */
  revisionCommit: string;

  /**
   * Output only. The latest commit in the path.
   *
   * @generated from field: string path_commit = 5;
   */
  pathCommit: string;
};

/**
 * Describes the message annealing.delivery.v1.GitSource.
 * Use `create(GitSourceSchema)` to create a new message.
 */
export const GitSourceSchema: GenMessage<GitSource> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 12);

/**
 * @generated from message annealing.delivery.v1.ChartSource
 */
export type ChartSource = Message<"annealing.delivery.v1.ChartSource"> & {
  /**
   * The chart repository containing application configuration.
   *
   * @generated from field: string repository = 1;
   */
  repository: string;

  /**
   * The name of the chart.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * The semantic version of the chart.
   *
   * @generated from field: string semantic_version = 3;
   */
  semanticVersion: string;

  /**
   * Output only. The exact version of the chart.
   *
   * @generated from field: string exact_version = 4;
   */
  exactVersion: string;
};

/**
 * Describes the message annealing.delivery.v1.ChartSource.
 * Use `create(ChartSourceSchema)` to create a new message.
 */
export const ChartSourceSchema: GenMessage<ChartSource> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 13);

/**
 * GoogleUser represents a linked Google account.
 *
 * @generated from message annealing.delivery.v1.GoogleUser
 */
export type GoogleUser = Message<"annealing.delivery.v1.GoogleUser"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message annealing.delivery.v1.GoogleUser.
 * Use `create(GoogleUserSchema)` to create a new message.
 */
export const GoogleUserSchema: GenMessage<GoogleUser> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 14);

/**
 * IncarnationFile represents a point-in-time snapshot of a file.
 *
 * @generated from message annealing.delivery.v1.IncarnationFile
 */
export type IncarnationFile = Message<"annealing.delivery.v1.IncarnationFile"> & {
  /**
   * The name of the file.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The path of the file.
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * The content of the file.
   *
   * @generated from field: string payload = 3;
   */
  payload: string;
};

/**
 * Describes the message annealing.delivery.v1.IncarnationFile.
 * Use `create(IncarnationFileSchema)` to create a new message.
 */
export const IncarnationFileSchema: GenMessage<IncarnationFile> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 15);

/**
 * IncarnationAsset represents a point-in-time snapshot of an object.
 *
 * @generated from message annealing.delivery.v1.IncarnationAsset
 */
export type IncarnationAsset = Message<"annealing.delivery.v1.IncarnationAsset"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string api_version = 2;
   */
  apiVersion: string;

  /**
   * @generated from field: string payload = 3;
   */
  payload: string;
};

/**
 * Describes the message annealing.delivery.v1.IncarnationAsset.
 * Use `create(IncarnationAssetSchema)` to create a new message.
 */
export const IncarnationAssetSchema: GenMessage<IncarnationAsset> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 16);

/**
 * @generated from message annealing.delivery.v1.AssetEvent
 */
export type AssetEvent = Message<"annealing.delivery.v1.AssetEvent"> & {
  /**
   * @generated from field: string object = 1;
   */
  object: string;

  /**
   * @generated from field: annealing.delivery.v1.AssetEventType event_type = 2;
   */
  eventType: AssetEventType;

  /**
   * @generated from field: google.protobuf.Timestamp event_time = 3;
   */
  eventTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.AssetEvent.
 * Use `create(AssetEventSchema)` to create a new message.
 */
export const AssetEventSchema: GenMessage<AssetEvent> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 17);

/**
 * @generated from message annealing.delivery.v1.Rollout
 */
export type Rollout = Message<"annealing.delivery.v1.Rollout"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string incarnation = 2;
   */
  incarnation: string;

  /**
   * @generated from field: int32 asset_count = 3;
   */
  assetCount: number;

  /**
   * @generated from field: annealing.delivery.v1.RolloutState state = 5;
   */
  state: RolloutState;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 6;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 7;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 8;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finish_time = 9;
   */
  finishTime?: Timestamp;

  /**
   * @generated from field: int32 total_step_count = 10;
   */
  totalStepCount: number;

  /**
   * @generated from field: int32 finished_step_count = 11;
   */
  finishedStepCount: number;
};

/**
 * Describes the message annealing.delivery.v1.Rollout.
 * Use `create(RolloutSchema)` to create a new message.
 */
export const RolloutSchema: GenMessage<Rollout> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 18);

/**
 * @generated from message annealing.delivery.v1.RolloutStep
 */
export type RolloutStep = Message<"annealing.delivery.v1.RolloutStep"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: annealing.delivery.v1.RolloutStepKind kind = 3;
   */
  kind: RolloutStepKind;

  /**
   * @generated from field: annealing.delivery.v1.RolloutStepState state = 4;
   */
  state: RolloutStepState;

  /**
   * @generated from field: int32 wave = 5;
   */
  wave: number;

  /**
   * @generated from field: int32 asset_count = 6;
   */
  assetCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 7;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 8;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 9;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finish_time = 10;
   */
  finishTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.RolloutStep.
 * Use `create(RolloutStepSchema)` to create a new message.
 */
export const RolloutStepSchema: GenMessage<RolloutStep> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 19);

/**
 * @generated from message annealing.delivery.v1.RolloutAsset
 */
export type RolloutAsset = Message<"annealing.delivery.v1.RolloutAsset"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 2;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 3;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.RolloutAsset.
 * Use `create(RolloutAssetSchema)` to create a new message.
 */
export const RolloutAssetSchema: GenMessage<RolloutAsset> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 20);

/**
 * @generated from message annealing.delivery.v1.ChartRepository
 */
export type ChartRepository = Message<"annealing.delivery.v1.ChartRepository"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string uri = 2;
   */
  uri: string;

  /**
   * @generated from field: annealing.delivery.v1.ChartRepositoryState state = 3;
   */
  state: ChartRepositoryState;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refresh_time = 6;
   */
  refreshTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.ChartRepository.
 * Use `create(ChartRepositorySchema)` to create a new message.
 */
export const ChartRepositorySchema: GenMessage<ChartRepository> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 21);

/**
 * @generated from message annealing.delivery.v1.GitRepository
 */
export type GitRepository = Message<"annealing.delivery.v1.GitRepository"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string uri = 2;
   */
  uri: string;

  /**
   * @generated from field: annealing.delivery.v1.GitRepositoryState state = 3;
   */
  state: GitRepositoryState;

  /**
   * @generated from field: annealing.delivery.v1.GitRepositoryAuthentication authentication = 4;
   */
  authentication?: GitRepositoryAuthentication;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 6;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refresh_time = 7;
   */
  refreshTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.GitRepository.
 * Use `create(GitRepositorySchema)` to create a new message.
 */
export const GitRepositorySchema: GenMessage<GitRepository> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 22);

/**
 * @generated from message annealing.delivery.v1.GitRepositoryAuthentication
 */
export type GitRepositoryAuthentication = Message<"annealing.delivery.v1.GitRepositoryAuthentication"> & {
  /**
   * @generated from field: string ssh_key = 1;
   */
  sshKey: string;
};

/**
 * Describes the message annealing.delivery.v1.GitRepositoryAuthentication.
 * Use `create(GitRepositoryAuthenticationSchema)` to create a new message.
 */
export const GitRepositoryAuthenticationSchema: GenMessage<GitRepositoryAuthentication> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 23);

/**
 * @generated from message annealing.delivery.v1.Chart
 */
export type Chart = Message<"annealing.delivery.v1.Chart"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string chart_version = 2;
   */
  chartVersion: string;

  /**
   * @generated from field: string app_version = 3;
   */
  appVersion: string;

  /**
   * @generated from field: string uri = 4;
   */
  uri: string;

  /**
   * @generated from field: string digest = 5;
   */
  digest: string;

  /**
   * @generated from field: annealing.delivery.v1.ChartState state = 6;
   */
  state: ChartState;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 7;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 8;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message annealing.delivery.v1.Chart.
 * Use `create(ChartSchema)` to create a new message.
 */
export const ChartSchema: GenMessage<Chart> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_resources, 24);

